






























import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {
  },
})
export default class Footer extends Vue {
  private isApp = false;

  private created() {
    if ((window as any).sangokukmy_app) {
      this.isApp = true;
    }
  }
}
